const rawPermissions = localStorage.getItem('permissions')
let permissions = null
let isPermissionsLoaded = false
try {
  const parsed = JSON.parse(rawPermissions)
  if (parsed && typeof parsed === 'object') {
    permissions = parsed || null
    isPermissionsLoaded = true
  }
} catch {
  permissions = null
}

let passwordChangeToken = null
try {
  passwordChangeToken = sessionStorage.getItem('passwordChangeToken') || null
} catch {
  passwordChangeToken = null
}

const state = {
  permissions,
  isPermissionsLoaded,
  // Scoped token handed out by /csms/login when the password is older than the
  // rotation period. Only /csms/change-expired-password accepts it.
  passwordChangeToken,
  companyID: parseInt(localStorage.getItem('companyID'), 10),
  canViewEvoAppLeads: localStorage.getItem('canViewEvoAppLeads') === 'true',
  userFullname: localStorage.getItem('userFullname') || null,
  userTitle: localStorage.getItem('userTitle') || null,
  username: localStorage.getItem('username') || null,
  token: localStorage.getItem('token') || null
}

export default state
